export const multipleNotification: {id:string,title:string}[] = [
    {
        id: 'include',
        title: 'Incluir no dashboard'
    },
    {
        id: 'no_include',
        title: 'Não incluir no dashboard',
    },
    {
        id: 'only_multiple',
        title: 'Mostrar apenas as Notificações em massa',
    },
]
